
import { Icon } from "@portal/lib/icons/icons";
import { LOGIN_ERROR_STATUS } from "@portal/types/common";
import { OTPErrorInfoConfig } from "./AlterInfo";

const loginErrorConfig: OTPErrorInfoConfig = {
  DELETED_USER: {
    message: "User does not have permission. Contact administrator.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  CRM_USERS_NOT_ALLOWED: {
    message: "User does not have permission. Contact administrator.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  NOT_A_VALID_CONTACT: {
    message: "User does not have permission. Contact administrator.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  OTP_LIMIT_REACHED: {
    message: " OTP retry limit has exceeded. Please try after 10 mins",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  OTP_WAIT_TIME: {
    message: "OTP already generated. Please try after 2 minutes",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  OTP_NOT_FOUND: {
    message: "Valid OTP not found",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  OTP_NOT_MATCHING: {
    message: "Wrong PIN entered. Try again",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  PORTAL_NOT_ENABLED: {
    message: "Customer portal is not enabled.Contact administrator.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  DEFAULT: {
    message: "Something went wrong. Please try again later.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
  NO_MATCHING_CUSTOMERS: {
    message: "Customer does not exist.",
    icon: <Icon icon={['far','times-circle']} color="var(--red-6)" />,
  },
};

export function getLoginErrorConfig(status: LOGIN_ERROR_STATUS) {
  return loginErrorConfig[status];
}
